import { useEffect } from 'react';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { MsalProvider } from '@azure/msal-react';
import { AuthProvider } from '../context/AuthProvider';
import { createMsalAuthClient } from '../msal/createMsalAuthClient';
import { jsx as _jsx } from "react/jsx-runtime";
export const AuthOverlay = _ref => {
  let {
    authConfig,
    children
  } = _ref;
  // MSAL's silent token renewal loads the redirect URI (the app itself) in a hidden iframe and waits for that page to
  // post the auth response back to the main window. Starting the app there would make MSAL throw block_iframe_reload.
  const isMsalSilentIframe = window.parent !== window && /[#&](code|error)=/.test(window.location.hash);
  useEffect(() => {
    if (isMsalSilentIframe) {
      broadcastResponseToMainFrame();
    }
  }, [isMsalSilentIframe]);
  if (isMsalSilentIframe) {
    return null;
  }
  const authClient = createMsalAuthClient(authConfig);
  return /*#__PURE__*/_jsx(MsalProvider, {
    instance: authClient,
    children: /*#__PURE__*/_jsx(AuthProvider, {
      authConfig: authConfig,
      children: children
    })
  });
};